'use client';

import React from 'react';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxText from '@components/ParallaxText';
import cn from './style.module.scss';
interface AlGhadeerTitleProps {
  titleData: string;
}
export default function AlGhadeerTitle({ titleData }: AlGhadeerTitleProps) {
  return (
    <ParallaxText
      className={cn.alGhadeerTitle}
      variant="h3"
      animationType="slideInBottom"
      animationDuration={500}
    >
      {ReactHtmlParser(titleData)}
    </ParallaxText>
  );
}
